module.exports = __webpack_public_path__ + "static/media/frurlkey.859f64de.png";